module.exports = __webpack_public_path__ + "img/symbol_6.05f87d6c.png";